import { useDispatch, useSelector } from 'react-redux';

const useOrganization = () => {
  const dispatch = useDispatch();
  const { errors = {}, organization: data } = useSelector(state => ({
    errors: state.errors.organization,
    organization: state.organization,
  }));
  const isLoading = useSelector(state => state.loading.effects.organization.join);

  const join = id => dispatch.organization.join(id);

  return {
    join,
    isLoading,
    data,
    errors,
  };
};

export default useOrganization;
